export default class CustomFormatter {
  // eslint-disable-next-line class-methods-use-this
  interpolate(message, values) {
    if (!values) return [message];

    const result = message.replace(/{{\s*(\w+)\s*}}/g, (_, key) => (values[key] !== undefined ? values[key] : ''));

    return [result];
  }
}
